<template>
    <div class="header-container">
        <router-link tag="a" to="/"><img src="../../assets/img/VIP Racing Logo Long Scaled.png"></router-link>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.header-container {
    position: fixed;
    top: 0;
    left: 0;
    background-color: #808080;
    width: 100%;
    height: 50px;
    padding: 10px;
    text-align: center;
    border-bottom: 2px solid darken(rgba(56, 90, 102, 0.75), 15%);
    z-index: 10;

    img {
        max-height: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/layout/Header.vue